<template>
    <div class="member min-height">
        <div class="flex align-center justify-between">
            <el-row :gutter="20" style="width: 100%">
                <el-col :span="6" class="search-some">
                    <span>企业名称：</span>
                    <el-input v-model="company_name" placeholder="请输入企业名称"></el-input>
                </el-col>
                <el-col :span="24">
                    <div class="mune-title margin-bottom-sm flex align-center" @click="isZongExpend = !isZongExpend">
                        <div>综合实力</div>
                        <i :class="isZongExpend ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" class="margin-left-sm"></i>
                    </div>
                </el-col>
                <div v-show="isZongExpend">
                    <el-col :span="6" class="search-some">
                        <span>注册资本：</span>
                        <el-select v-model="register_capital" class="w-all" placeholder="请选择">
                            <el-option
                                v-for="item in moneyList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>连续经营年限：</span>
                        <el-select
                            v-model="register_years"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in jYearList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>社保员工人数：</span>
                        <el-select
                            v-model="social_security_number"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in sheBaoNumberList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>会员年限：</span>
                        <el-select
                            v-model="member_years"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in vipYearList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>消防技术服务从业条件：</span>
                        <el-select
                            v-model="practice_condition"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in serviceList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>

                    <el-col :span="6" class="search-some">
                        <span>信息类相关资质及证书：</span>
                        <el-select
                            v-model="information_qualification"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in informationQualificationList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>教育培训类相关资质及证书：</span>
                        <el-select
                            v-model="education_and_training"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in educationTrainingList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>排油烟大气环保相关资质及证书：</span>
                        <el-select
                            v-model="lampblack"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in lampblackList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>消防产品相关资质及证书：</span>
                        <el-select
                            v-model="fire_products"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in fireProductList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>建筑、消防施工等相关资质及证书：</span>
                        <el-select
                            v-model="construction_construction"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in zizhiList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>消防行业相关专利证书：</span>
                        <el-select
                            v-model="patent_certificate"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in hasList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>政府有关部门认可的示范项目：</span>
                        <el-select
                            v-model="government_projects"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in hasList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>消防相关行业协会认可的示范项目：</span>
                        <el-select
                            v-model="association_project"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in hasList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>获得过本行业相关认证：</span>
                        <el-select
                            v-model="industry_certification"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in hasList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>具有非上述类相关资质及证书：</span>
                        <el-select
                            v-model="above_related"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in hasList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>主营消防服务及特点：</span>
                        <el-select
                            v-model="fire_services_features"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in supply"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="12" class="search-some">
                        <span>主营消防产品及特点：</span>
                        <el-cascader v-model="fire_products_features" :options="productList" filterable style="width: 100%"></el-cascader>
                    </el-col>


                </div>
                <el-col :span="24">
                    <div class="mune-title margin-bottom-sm flex align-center" @click="isYjExpend = !isYjExpend">
                        <div>业绩信息</div>
                        <i :class="isYjExpend ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" class="margin-left-sm"></i>
                    </div>
                </el-col>
                <div  v-show="isYjExpend">
                    <el-col :span="6" class="search-some">
                        <span>近三年消防行业业务项目数量：</span>
                        <el-select
                            v-model="management_number"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in bigNumList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>近三年消防行业营业收入：</span>
                        <el-select
                            v-model="business_income"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in ysMoneyList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>近三年政府购买服务项目：</span>
                        <el-select
                            v-model="service_experience_number"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in serviceNumList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>典型项目：</span>
                        <el-select
                            v-model="exponent"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in stateList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                </div>
                <el-col :span="24">
                    <div class="mune-title margin-bottom-sm flex align-center" @click="isXyExpend = !isXyExpend">
                        <div>信用信息</div>
                        <i :class="isXyExpend ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" class="margin-left-sm"></i>
                    </div>
                </el-col>
                <div  v-show="isXyExpend">
                    <el-col :span="6" class="search-some">
                        <span>总队信用评价：</span>
                        <el-select
                            v-model="corps_credit"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in stateList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>协会信用评价：</span>
                        <el-select
                            v-model="association_credit"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in stateList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>社会信用评价：</span>
                        <el-select
                            v-model="social_credit"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in stateList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>信用评价事件：</span>
                        <el-select
                            v-model="assessment"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in stateList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                </div>
                <el-col :span="24">
                    <div class="mune-title margin-bottom-sm flex align-center" @click="isGxExpend = !isGxExpend">
                        <div>贡献信息</div>
                        <i :class="isGxExpend ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" class="margin-left-sm"></i>
                    </div>
                </el-col>
                <div v-show="isGxExpend">
                    <el-col :span="6" class="search-some">
                        <span>是否提出立法方面的意见和建议：</span>
                        <el-select
                            v-model="is_legislation"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in stateList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>是否提出政策方面的意见和建议：</span>
                        <el-select
                            v-model="is_policy"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in stateList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>是否提出标准方面的意见和建议：</span>
                        <el-select
                            v-model="is_standard"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in stateList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>是否提出市场方面的意见和建议：</span>
                        <el-select
                            v-model="is_market"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in stateList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>是否提出调研方面的意见和建议：</span>
                        <el-select
                            v-model="is_investigation"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in stateList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>是否参与制定国标：</span>
                        <el-select
                            v-model="standards"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in stateList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>是否参与制定地标：</span>
                        <el-select
                            v-model="landmarks"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in stateList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>是否参与制定团标：</span>
                        <el-select
                            v-model="make_group"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in stateList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>是否参与制定协会行业服务标准：</span>
                        <el-select
                            v-model="association_association"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in stateList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>是否参与质量现场核查工作：</span>
                        <el-select
                            v-model="scene_check"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in stateList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>宣传协会频次(上自然年度)：</span>
                        <el-select
                            v-model="propaganda_last"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in hasList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>宣传协会频次(本自然年度)：</span>
                        <el-select
                            v-model="propaganda_this"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in hasList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>发展会员数量(上自然年度)：</span>
                        <el-select
                            v-model="recommend_last"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in hasList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>发展会员数量(本自然年度)：</span>
                        <el-select
                            v-model="recommend_this"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in hasList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>联系会员频次(上自然年度)：</span>
                        <el-select
                            v-model="contact_member_last"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in hasList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>联系会员频次(本自然年度)：</span>
                        <el-select
                            v-model="contact_member_this"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in hasList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>联系会员频次(本自然年度)：</span>
                        <el-select
                            v-model="contact_member_this"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in hasList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                </div>

                <el-col :span="24">
                    <div class="mune-title margin-bottom-sm flex align-center" @click="isExpend = !isExpend">
                        <div>关联信息</div>
                        <i :class="isExpend ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" class="margin-left-sm"></i>
                    </div>
                </el-col>
                <div v-show="isExpend">
                    <el-col :span="6" class="search-some">
                        <span>联络人：</span>
                        <el-input v-model="contact_person" placeholder="请输入联络人"></el-input>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>联络电话：</span>
                        <el-input v-model="contact_phone" placeholder="请输入联络电话"></el-input>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>被联系的上家会员单位：</span>
                        <el-select
                            v-model="higher_level"
                            class="w-all"
                            filterable placeholder="请选择">
                            <el-option
                                v-for="item in oneLevelLabels.filter(f=>{ return (f.level !=3 && f.level) || f.level == 0})"
                                :key="item.id"
                                :label="item.company_name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>联系的下家会员单位：</span>
                        <el-select
                            v-model="lower_level"
                            class="w-all"
                            filterable placeholder="请选择">
                            <el-option
                                v-for="item in oneLevelLabels.filter(f=>{ return (f.level != 1 && f.level) || f.level == 0})"
                                :key="item.id"
                                :label="item.company_name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" class="search-some">
                        <span>介绍会员单位入会：</span>
                        <el-select
                            v-model="introduction_unit_ids"
                            class="w-all"
                            filterable placeholder="请选择">
                            <el-option
                                v-for="item in introductionLabels"
                                :key="item.user_id"
                                :label="item.company_name"
                                :value="item.user_id">
                            </el-option>
                        </el-select>
                    </el-col>


                    <el-col :span="6" class="search-some">
                        <span>互动标签：</span>
                        <el-select
                            v-model="interactive_information"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in informationLabels"
                                :key="item.id"
                                :label="item.title"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-col>

                    <el-col :span="6" class="search-some">
                        <span>合作单位：</span>
                        <el-select
                            v-model="related_information"
                            class="w-all"
                            placeholder="请选择">
                            <el-option
                                v-for="item in relatedLabels"
                                :key="item.user_id"
                                :label="item.company_name"
                                :value="item.user_id">
                            </el-option>
                        </el-select>
                    </el-col>
                </div>

                <el-col :span="24">
                    <div class="flex align-center justify-end padding-bottom-sm">
                        <el-button
                            class="margin-left font-size"
                            type="primary"
                            @click="search"
                        >搜索
                        </el-button>
                        <el-button
                            class="margin-left font-size"
                            type="primary"
                            @click="reset"
                        >重置
                        </el-button>
                        <el-button
                            class="margin-left font-size"
                            type="primary"
                            @click="exportExcel"
                        >导出
                        </el-button>
                        <el-button
                            class="margin-left font-size"
                            type="primary"
                            @click="toLabel"
                        >互动标签管理
                        </el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <el-table
            ref="multipleTable"
            :data="tableData"
            alig="center"
            border
            header-row-class-name="table-header"
            row-class-name="table-row"
            style="width: 100%"
            tooltip-effect="dark">
            <el-table-column label="序号" type="" width="80">
                <template slot-scope="scope">
                    {{ (page - 1) * 10 + scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column label="企业全称" prop="company_name" width="200px">
            </el-table-column>
            <el-table-column label="联络级别" prop="level">
                <template slot-scope="scope">
                    {{ scope.row.level }}级
                </template>
            </el-table-column>
            <el-table-column label="联络员" prop="contact_person" width="150px"></el-table-column>
            <el-table-column label="电话" prop="contact_phone" width="150px"></el-table-column>
            <el-table-column label="单位类型" prop="company_type" width="150px"></el-table-column>
            <el-table-column label="专委会" prop="special_job" width="200px"></el-table-column>
            <el-table-column label="被联系的上家会员单位" prop="higher_company_name" width="200px"></el-table-column>
            <el-table-column label="会员证书到期时间" prop="valid_time_end_time" width="150px"></el-table-column>
            <el-table-column label="上级联络员" prop="higher_contact_person" width="150px"></el-table-column>
            <el-table-column label="上级电话" prop="higher_contact_phone" width="150px">
            </el-table-column>
            <el-table-column label="注册资本" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.register_capital | register_capital }}
                </template>
            </el-table-column>
            <el-table-column label="连续经营年限" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.register_years | register_years }}
                </template>
            </el-table-column>
            <el-table-column label="社保员工人数" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.social_security_number | social_security_number }}
                </template>
            </el-table-column>
            <el-table-column label="会员年限" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.member_years | member_years }}
                </template>
            </el-table-column>
            <el-table-column label="消防技术服务从业条件" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.practice_condition | practice_condition }}
                </template>
            </el-table-column>
            <el-table-column label="信息类相关资质及证书" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.information_qualification | information_qualification }}
                </template>
            </el-table-column>
            <el-table-column label="教育培训类相关资质及证书" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.education_and_training | education_and_training }}
                </template>
            </el-table-column>
            <el-table-column label="排油烟大气环保相关资质及证书" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.lampblack | lampblack }}
                </template>
            </el-table-column>
            <el-table-column label="消防产品相关资质及证书" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.fire_products | fire_products }}
                </template>
            </el-table-column>

            <el-table-column label="建筑、消防施工等相关资质及证书" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.construction_construction | construction_construction }}
                </template>
            </el-table-column>
            <el-table-column label="消防行业相关专利证书" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.patent_certificate | has_state }}
                </template>
            </el-table-column>
            <el-table-column label="政府有关部门认可的示范项目" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.government_projects | has_state }}
                </template>
            </el-table-column>
            <el-table-column label="消防相关行业协会认可的示范项目" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.association_project | has_state }}
                </template>
            </el-table-column>
            <el-table-column label="获得过本行业相关认证" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.industry_certification | has_state }}
                </template>
            </el-table-column>
            <el-table-column label="具有非上述类相关资质及证书" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.above_related | has_state }}
                </template>
            </el-table-column>
            <el-table-column label="主营消防产品及特点" width="150px">
                <template slot-scope="scope">
                    <div style="word-break: break-all;white-space: break-spaces;">{{ scope.row.fire_products_features | fire_products_features }}</div>
                </template>
            </el-table-column>
            <el-table-column label="主营消防服务及特点" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.fire_services_features | fire_services_features }}
                </template>
            </el-table-column>
            <el-table-column label="近三年消防行业业务项目数量" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.management_number | management_number }}
                </template>
            </el-table-column>
            <el-table-column label="近三年消防行业营业收入" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.business_income | business_income }}
                </template>
            </el-table-column>
            <el-table-column label="近三年政府购买服务项目" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.service_experience_number | service_experience_number }}
                </template>
            </el-table-column>
            <el-table-column label="典型项目" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.exponent | has_state }}
                </template>
            </el-table-column>
            <el-table-column label="总队信用评价" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.corps_credit | has }}
                </template>
            </el-table-column>
            <el-table-column label="协会信用评价" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.association_credit | has }}
                </template>
            </el-table-column>
            <el-table-column label="社会信用评价" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.social_credit | has }}
                </template>
            </el-table-column>
            <el-table-column label="信用评价事件" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.assessment | has }}
                </template>
            </el-table-column>
            <el-table-column label="是否提出立法方面的意见和建议" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.is_legislation | state }}
                </template>
            </el-table-column>
            <el-table-column label="是否提出政策方面的意见和建议" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.is_policy | state }}
                </template>
            </el-table-column>
            <el-table-column label="是否提出标准方面的意见和建议" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.is_standard | state }}
                </template>
            </el-table-column>
            <el-table-column label="是否提出市场方面的意见和建议" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.is_market | state }}
                </template>
            </el-table-column>
            <el-table-column label="是否提出调研方面的意见和建议" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.is_investigation | state }}
                </template>
            </el-table-column>
            <el-table-column label="是否参与制定国标" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.standards | state }}
                </template>
            </el-table-column>
            <el-table-column label="是否参与制定地标" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.landmarks | state }}
                </template>
            </el-table-column>
            <el-table-column label="是否参与制定团标" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.make_group | state }}
                </template>
            </el-table-column>
            <el-table-column label="是否参与制定协会行业服务标准" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.association_association | state }}
                </template>
            </el-table-column>
            <el-table-column label="是否参与质量现场核查工作" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.scene_check | state }}
                </template>
            </el-table-column>
            <el-table-column label="宣传协会频次(上自然年度)" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.propaganda_last_num_num || '--' }}
                </template>
            </el-table-column>
            <el-table-column label="宣传协会频次(本自然年度)" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.propaganda_this_num || '--' }}
                </template>
            </el-table-column>
            <el-table-column label="发展会员数量(上自然年度)" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.recommend_last_num || '--' }}
                </template>
            </el-table-column>
            <el-table-column label="发展会员数量(本自然年度)" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.recommend_this_num || '--' }}
                </template>
            </el-table-column>
            <el-table-column label="联系会员频次(上自然年度)" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.contact_member_last_num || '--' }}
                </template>
            </el-table-column>
            <el-table-column label="联系会员频次(本自然年度)" width="150px">
                <template slot-scope="scope">
                    {{ scope.row.contact_member_this_num || '--' }}
                </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="130px">
                <template slot-scope="scope">
                    <el-button
                        class="font-size"
                        size="medium"
                        type="primary"
                        @click="toCredit(scope.row.id,scope.row.user_id)">
                        <i class="margin-right-xs font-size el-icon-document"></i>详情
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="flex align-center justify-between padding-top-sm">
            <span>共{{ total }}条数据</span>
            <el-pagination
                v-if="tableData.length > 0"
                :current-page.sync="page"
                :page-size="limit"
                :total="total"
                background
                layout="prev, pager, next, jumper"
                @current-change="getList"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>

import {
    bigNumList,
    creditLevelList,
    educationTrainingList,
    filesCN,
    fireProductList,
    hasList,
    informationQualificationList,
    jYearList,
    lampblackList,
    moneyList,
    productList,
    serviceList,
    serviceNumList,
    sheBaoNumberList,
    stateList,
    supply,
    vipNumList,
    vipYearList,
    ysMoneyList,
    zizhiList
} from '@/utils/utils'
import {getAllContactCompany, getCreditList, getSelectcompany} from "@/api/admin";
import {getCompany, getInformationLabel} from "@/api/member";
import {UDHOST} from "@/config";

export default {
    name: "member",
    data() {
        return {
            moneyList: moneyList,
            jYearList: jYearList,
            sheBaoNumberList: sheBaoNumberList,
            serviceList: serviceList,
            informationQualificationList: informationQualificationList,
            educationTrainingList: educationTrainingList,
            lampblackList: lampblackList,
            fireProductList: fireProductList,
            zizhiList: zizhiList,
            vipYearList: vipYearList,
            bigNumList: bigNumList,
            ysMoneyList: ysMoneyList,
            serviceNumList: serviceNumList,
            vipNumList: vipNumList,
            stateList: stateList,
            creditLevelList: creditLevelList,
            hasList: hasList,
            productList: productList,
            supply: supply,

            company_name: '',//	-	Text	是公司名称
            register_capital: '',//	-	Text	是注册资本
            register_years: '',//	-	Text	是连续经营年限
            social_security_number: '',//	-	Text	是社保人数
            member_years: '',//	-	Text	是会员年限
            practice_condition: '',//	-	Text	是消防技术服务机构从业条件
            information_qualification: '',//	-	Text	是信息类相关资质及证书
            education_and_training: '',//	-	Text	是教育培训类相关资质及证书
            lampblack: '',//	-	Text	是排油烟大气环保相关资质及证书
            fire_products: '',//	-	Text	是消防产品相关资质及证书
            construction_construction: '',//	-	Text	是建筑、消防施工等相关资质及证书
            patent_certificate: '',//	-	Text	是消防行业相关专利证书
            government_projects: '',//	-	Text	是政府有关部门认可的示范项目
            association_project: '',//	-	Text	是消防相关行业协会认可的示范项目
            industry_certification: '',//	-	Text	是获得过本行业相关认证
            above_related: '',//	-	Text	是具有非上述类相关资质及证书
            fire_products_features: [''],//	-	Text	是主营消防产品及特点
            fire_services_features: 0,//	-	Text	是主营消防服务及特点
            management_number: '',//	-	Text	是近三年消防行业业务项目数量
            business_income: '',//	-	Text	是近三年消防行业营业收入
            service_experience_number: '',//	-	Text	是近三年政府购买服务项目
            exponent: '',//	-	Text	是典型项目  0无 1有
            corps_credit: '',//	-	Text	是总队信用评价 0否 1是
            association_credit: '',//	-	Text	是协会信用评价 0否 1是
            social_credit: '',//	-	Text	是社会信用评价 0否 1是
            assessment: '',//	-	Text	是信用评价事件 0否 1是
            is_legislation: '',//	-	Text	是是否提出立法方面的意见和建议 0否 1是
            is_policy: '',//	-	Text	是是否提出政策方面的意见和建议 0否 1是
            is_standard: '',//	-	Text	是是否提出标准方面的意见和建议 0否 1是
            is_market: '',//	-	Text	是是否提出市场方面的意见和建议 0否 1是
            is_investigation: '',//	-	Text	是是否提出调研方面的意见和建议 0否 1是
            standards: '',//	-	Text	是是否参与制定国标 0否 1是
            landmarks: '',//	-	Text	是是否参与制定地标 0 否 1是
            make_group: '',//	-	Text	是是否参与制定团体 0否 1是
            association_association: '',//	-	Text	是是否参与制定协会行业服务标准 0否 1是
            scene_check: '',//	-	Text	是是否参与质量现场核查工作 0否 1是
            propaganda_last: '',//	-	Text	是宣传协会频次 去年 0无 1有
            propaganda_last_num: '',//	-	Text	是宣传协会频次 去年次数
            propaganda_this: '',//	-	Text	是宣传协会频次 本年 0无 1有
            propaganda_this_num: '',//	-	Text	是宣传协会频次 本年次数
            recommend_last: '',//	-	Text	是发展会员数量 去年 0无 1有
            recommend_last_num: '',//	-	Text	是发展会员数量 去年数量
            recommend_this: '',//	-	Text	是发展会员数量 本年 0无 1有
            recommend_this_num: '',//	-	Text	是发展会员数量 本年数量
            contact_member_last: '',//	-	Text	是联系会员频次 去年 0无 1有
            contact_member_last_num: '',//	-	Text	是联系会员频次 去年次数
            contact_member_this: '',//	-	Text	是联系会员频次 本年 0无 1有
            contact_member_this_num: '',//	-	Text	是联系会员频次 本年次数
            higher_level: '',//	-	Text	是上级单位ID
            lower_level: '',//	-	Text	是下级单位IDs
            introduction_unit_ids: '',//	-	Text	是介绍会员单位入会
            interactive_information: '',//	-	Text	是合作会员单位
            related_information: '',//	-	Text	是与协会互动信息
            contact_person: '',//	-	Text	是联络人
            contact_phone: '',//	-	Text	是联络电话

            page: 1,
            limit: 10,
            total: 0,
            tableData: [],

            informationLabels: [],
            relatedLabels: [],
            oneLevelLabels: [],
            introductionLabels: [],
            isZongExpend: false,
            isXyExpend: false,
            isYjExpend: false,
            isGxExpend: false,
            isExpend: false,
        }
    },
    created() {
        this.$emit("setIndex", this.$route.path, "信用信息管理  / ", false, 'icon-yonghu');
        this.getList()
        this.init()
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    components: {},

    methods: {
        async init() {
            let _data = await getInformationLabel()
            _data.data.unshift({
                id: '',
                title: '全部'
            })
            this.informationLabels = _data.data
            _data = await getCompany()
            _data.data.unshift({
                user_id: '',
                company_name: '全部'
            })
            this.relatedLabels = _data.data
            _data = await getAllContactCompany()
            _data.data.unshift({
                id: '',
                level: 0,
                company_name: '全部'
            })
            this.oneLevelLabels = _data.data
            _data = await getSelectcompany()
            _data.data.unshift({
                user_id: '',
                company_name: '全部'
            })
            this.introductionLabels = _data.data
        },
        //  详情
        toCredit(id, user_id) {
            this.$router.push(`/admin/credit/${id}/${user_id}/1`)
        },  //  详情
        toLabel() {
            this.$router.push('/admin/interactiveLabel')
        },
        //  重置
        reset() {
            this.company_name = ''
            this.register_capital = ''
            this.register_years = ''
            this.social_security_number = ''
            this.member_years = ''
            this.practice_condition = ''
            this.information_qualification = ''
            this.education_and_training = ''
            this.lampblack = ''
            this.fire_products = ''
            this.construction_construction = ''
            this.patent_certificate = ''
            this.government_projects = ''
            this.association_project = ''
            this.industry_certification = ''
            this.above_related = ''
            this.fire_products_features = ['']
            this.fire_services_features = 0
            this.management_number = ''
            this.business_income = ''
            this.service_experience_number = ''
            this.exponent = ''
            this.corps_credit = ''
            this.association_credit = ''
            this.social_credit = ''
            this.assessment = ''
            this.is_legislation = ''
            this.is_policy = ''
            this.is_standard = ''
            this.is_market = ''
            this.is_investigation = ''
            this.standards = ''
            this.landmarks = ''
            this.make_group = ''
            this.association_association = ''
            this.scene_check = ''
            this.propaganda_last = ''
            this.propaganda_last_num = ''
            this.propaganda_this = ''
            this.propaganda_this_num = ''
            this.recommend_last = ''
            this.recommend_last_num = ''
            this.recommend_this = ''
            this.recommend_this_num = ''
            this.contact_member_last = ''
            this.contact_member_last_num = ''
            this.contact_member_this = ''
            this.contact_member_this_num = ''
            this.higher_level = ''
            this.lower_level = ''
            this.introduction_unit_ids = ''
            this.interactive_information = ''
            this.related_information = ''
            this.contact_person = ''
            this.contact_phone = ''
            this.page = 1
            this.getList()
        },
        //  搜索
        search() {
            this.page = 1
            this.getList()
        },
        //  获取列表
        async getList() {
            let _list = await getCreditList(
                this.company_name,
                this.register_capital,
                this.register_years,
                this.social_security_number,
                this.member_years,
                this.practice_condition,
                this.information_qualification,
                this.education_and_training,
                this.lampblack,
                this.fire_products,
                this.construction_construction,
                this.patent_certificate,
                this.government_projects,
                this.association_project,
                this.industry_certification,
                this.above_related,
                this.fire_products_features.length === 3 ? `"type":${this.fire_products_features[0]},"classify":${this.fire_products_features[1]},"cate":${this.fire_products_features[2]}` : '',
                this.fire_services_features ? `"type":${this.fire_services_features}` : '',
                this.management_number,
                this.business_income,
                this.service_experience_number,
                this.exponent,
                this.corps_credit,
                this.association_credit,
                this.social_credit,
                this.assessment,
                this.is_legislation,
                this.is_policy,
                this.is_standard,
                this.is_market,
                this.is_investigation,
                this.standards,
                this.landmarks,
                this.make_group,
                this.association_association,
                this.scene_check,
                this.propaganda_last,
                this.propaganda_last_num,
                this.propaganda_this,
                this.propaganda_this_num,
                this.recommend_last,
                this.recommend_last_num,
                this.recommend_this,
                this.recommend_this_num,
                this.contact_member_last,
                this.contact_member_last_num,
                this.contact_member_this,
                this.contact_member_this_num,
                this.higher_level,
                this.lower_level,
                this.introduction_unit_ids,
                this.interactive_information,
                this.related_information,
                this.contact_person,
                this.contact_phone,
                this.page
            )
            this.tableData = _list.data.data
            this.total = _list.data.total
        },
        exportExcel() {
            window.open(`${UDHOST}/api/Index/companyCreditDataExport?company_name=${this.company_name
            }&register_capital=${this.register_capital
            }&register_years=${this.register_years
            }&social_security_number=${this.social_security_number
            }&member_years=${this.member_years
            }&practice_condition=${this.practice_condition
            }&information_qualification=${this.information_qualification
            }&education_and_training=${this.education_and_training
            }&lampblack=${this.lampblack
            }&fire_products=${this.fire_products
            }&construction_construction=${this.construction_construction
            }&patent_certificate=${this.patent_certificate
            }&government_projects=${this.government_projects
            }&association_project=${this.association_project
            }&industry_certification=${this.industry_certification
            }&above_related=${this.above_related
            }&fire_products_features=${this.fire_products_features.length === 3 ? `"type":${this.fire_products_features[0]},"classify":${this.fire_products_features[1]},"cate":${this.fire_products_features[2]}` : ''
            }&fire_services_features=${this.fire_services_features ? `"type":${this.fire_services_features}` : ''
            }&management_number=${this.management_number
            }&business_income=${this.business_income
            }&service_experience_number=${this.service_experience_number
            }&exponent=${this.exponent
            }&corps_credit=${this.corps_credit
            }&association_credit=${this.association_credit
            }&social_credit=${this.social_credit
            }&assessment=${this.assessment
            }&is_legislation=${this.is_legislation
            }&is_policy=${this.is_policy
            }&is_standard=${this.is_standard
            }&is_market=${this.is_market
            }&is_investigation=${this.is_investigation
            }&standards=${this.standards
            }&landmarks=${this.landmarks
            }&make_group=${this.make_group
            }&association_association=${this.association_association
            }&scene_check=${this.scene_check
            }&propaganda_last=${this.propaganda_last
            }&propaganda_last_num=${this.propaganda_last_num
            }&propaganda_this=${this.propaganda_this
            }&propaganda_this_num=${this.propaganda_this_num
            }&recommend_last=${this.recommend_last
            }&recommend_last_num=${this.recommend_last_num
            }&recommend_this=${this.recommend_this
            }&recommend_this_num=${this.recommend_this_num
            }&contact_member_last=${this.contact_member_last
            }&contact_member_last_num=${this.contact_member_last_num
            }&contact_member_this=${this.contact_member_this
            }&contact_member_this_num=${this.contact_member_this_num
            }&higher_level=${this.higher_level
            }&lower_level=${this.lower_level
            }&introduction_unit_ids=${this.introduction_unit_ids
            }&interactive_information=${this.interactive_information
            }&related_information=${this.related_information
            }&contact_person=${this.contact_person
            }&contact_phone=${this.contact_phone}`)
        }
    },
    filters: {
        register_capital(val) {
            return filesCN(Number(val), moneyList)
        },
        register_years(val) {
            return filesCN(Number(val), jYearList)
        },
        social_security_number(val) {
            return filesCN(Number(val), sheBaoNumberList)
        },
        practice_condition(val) {
            return val ? JSON.parse(val).map((item) => {
                return filesCN(item.id, serviceList)
            }).join(',') : ''
        },
        information_qualification(val) {
            return val?  JSON.parse(val).map((item) => {
                return filesCN(item.id, informationQualificationList)
            }).join(',') : ''
        },
        education_and_training(val) {
            return val ? JSON.parse(val).map((item) => {
                return filesCN(item.id, educationTrainingList)
            }).join(',') : ''
        },
        lampblack(val) {
            return val ? JSON.parse(val).map((item) => {
                return filesCN(item.id, lampblackList)
            }).join(',') : ''
        },
        fire_products(val) {
            return val ? JSON.parse(val).map((item) => {
                return filesCN(item.id, fireProductList)
            }).join(',') : ''
        },
        member_years(val) {
            return filesCN(Number(val), vipYearList)
        },
        construction_construction(val) {
            return val ? JSON.parse(val).map((item) => {
                return filesCN(item.id, zizhiList)
            }).join(',') : ''
        },
        fire_services_features(val) {
            return val ? JSON.parse(val).map((item) => {
                return filesCN(item.type, supply)
            }).join(',') : ''
        },
        fire_products_features(val) {
            return val ? JSON.parse(val).map((item) => {
                let find = productList.find(f => f.value === Number(item.type))
                if (!find) return ``
                let child = find.children.find(f => f.value === Number(item.classify))
                if (!child) return `${find.label}`
                let _3_child = child.children.find(f => f.value === Number(item.cate))
                if (!_3_child) return `${find.label}-${child.label}`
                return `${find.label}-${child.label}-${_3_child.label}`
            }).join(',\n') : ''
        },
        has_state(val) {
            return val ? filesCN(JSON.parse(val).state, hasList) : ''
        },
        has(val) {
            return filesCN(Number(val), hasList)
        },
        management_number(val) {
            return filesCN(Number(val), bigNumList)
        },
        business_income(val) {
            return filesCN(Number(val), ysMoneyList)
        },
        service_experience_number(val) {
            return filesCN(Number(val), serviceNumList)
        },
        state(val) {
            return filesCN(Number(val), stateList)
        },
        recommend_num(val) {
            return filesCN(Number(val), vipNumList)
        }
    },
    watch: {
        memberType() {
            this.moreType = []
        }
    },
}
</script>

<style lang="scss" scoped>
.member {
    background: #fff;
    padding: 30px;
    border-radius: 8px;

    .mune-title {
        font-size: 16px;
        color: #0d7fd7;
        position: relative;
        cursor: pointer;

        &.first {
            font-size: 20px;

            &:before {
                position: absolute;
                top: 0;
                left: 0;
                content: "";
                width: 5px;
                height: 24px;
                background-color: #0d7fd7;
                border-radius: 2px;
            }
        }
    }

    .search-some {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
            display: block;
            flex-shrink: 0;
        }

        .el-input {
            flex: 1;
        }

        .el-select {
            flex: 1;
        }
    }
}
</style>